import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TimeoutService } from '../services/timeout.service';
import { map } from 'rxjs/operators';
import { IRequest } from '../entities/request.interface';

@Injectable()
export class BaseRepository {
  constructor(
    protected http: HttpClient,
    private timeoutService: TimeoutService
  ) { }

  protected post<T>(request: IRequest): Promise<T> {
    this.updateSessionTime();

    return this.http
      .post(request.Url,
        request.Body,
        {
          headers: new HttpHeaders().set("Content-Type", "application/json")
        }).pipe(map(data => <T>data))
      .toPromise();
    }

  protected get<T>(url: string, options = {}): Promise<T> {
    this.updateSessionTime();

    return this.http
      .get(url, options)
      .pipe(map(data => <T>data))
      .toPromise();
  }

  private updateSessionTime() {
    this.timeoutService.updateSessionValidTo();
  }
}
